<template>
  <div>
    <el-dialog
      title="优惠券领取记录"
      :visible.sync="dialogVisible"
      width="60%"
      @close="closeDialog"
    >
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        size="mini"
        v-loading="loading"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="会员信息" align="center">
          <template slot-scope="scope">
            <span
              >{{ scope.row.subscriberName }} /
              {{ scope.row.subscriberPhoneNo }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="couponName"
          label="优惠券名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="couponTypeName"
          label="优惠券类型"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="useStatusName" label="使用状态" align="center">
        </el-table-column>
        <el-table-column
          prop="created"
          label="领取时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="useTime"
          label="使用时间"
          align="center"
        ></el-table-column>
        <el-table-column prop="orderNo" label="订单号" align="center">
          <template slot-scope="scope">
            <!--el-link链接-->
            <el-link type="primary" @click="toOrderDetail(scope.row)">{{
              scope.row.orderNo
            }}</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { queryCouponHistoryPageApi } from "@/api/subscriber";
export default {
  name: "CouponHistory",
  data() {
    return {
      currentCoupon: null,
      dialogVisible: false,
      loading: false,
      tableData: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  mounted() {},
  methods: {
    openDialog(coupon) {
      this.currentCoupon = coupon;
      this.loadPage(1);
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit("closeDialog");
    },
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.searchForm.couponId = this.currentCoupon.id;
      this.loading = true;
      queryCouponHistoryPageApi(this.searchForm)
        .then(resp => {
          if (resp.data.status == 100) {
            this.tableData = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    /**
     * 订单详情
     * @param {*} orderNo
     */
    toOrderDetail(row) {
      this.$router.push({
        path: "/visitRepair",
        query: {
          orderId: row.orderId,
          orderNo: row.orderNo
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// history.vue?36073cdb